export default "__VITE_ASSET__CXvMn9GL__"